// backend validation error messages mapping ,
// add backend error messages to the ist ENABLE_ANALYZER

const responseErrorMapping = (error) => {
  const errorMappingList = {
    // Signup API Errors
    'Email address already exist!': 'Incorrect email',
    'KitchenName  already exist!': 'Incorrect branch name',
    'KitchenName already exist in kitchen address model!': 'Add address again',
    'Phone no already exist': 'Incorrect phone no',
    'Please enter operation start time in format "12:00 AM" !':
      'Start time format should be HH:MM AM',
    'Operation start time is mandatory!': 'Start time is mandatory',
    'kitchen account_type is mandatory!': 'bizType is mandatory',
    'Operation end time is mandatory!': 'End time is mandatory',
    'Please enter operation end time in format "12:00 AM" !': 'End time format should be HH:MM PM',
    'Cuisine mandatory!': 'Cuisine mandatory',
    'Password confirmation does not match password': 'Password and reType Password does not match',
    'Sorry we do not serve in your area':
      'Sorry, our services are currently unavailable at this location. We hope to serve you in future',

    //OTP Verify Token REACT_APP_KITCHEN_BACKEND_API_URL

    // Get serving zipcode  onServingZipcode

    'No Record Found in Database by that 95050':
      'We dont have service or avalablity in your selected category in your area, please give us your email we will reach out to you when we have spot open in your area',

    // Login Response
    'Incorrect email or password!': 'Invalid email or password!',
    'Incorrect password or email!': 'Invalid email or password!',
    'Something is seriouly wrong,This is last CATCH block':
      'Something went seriously wrong. Please contact support and provide reference - 449966',
    'There is no user with that email': 'There is no user with that email',

    //Reset password
    'Token Expired': 'Token is expired',
    'Invalid token in side body': 'Invalid reset token',
    'Password and retype password dont match!': 'Password and retype password dont match!',
    'Password update successfully!': 'Password update successfully!',

    // Add Product
    'Product name already exists for the given kitchen!':
      'Product name already exists in your menu',
    'kitchen_name is required': 'Store name is required',
    'product_sku is required': 'SKU is required — please provide a product SKU to continue.',
    'product_name is required': 'Product name is required',
    'serving_temperature is required': 'Serving temperature is required',
    'price is required': 'Price is required',
    'image_url is required': 'Product Image is required',
    'cuisine is required': 'Cuisine is required',
    'product_type is required': 'Product type is required',
    'available_quantity is required': 'Quantity is required',
    'product_category is required': 'Product category is required',
    'special_marking is required': 'Special marking is required',
    'Special marking required': 'Special marking is required',
    'Serving temperature required': 'Serving temperature is required',
    'Serving days required': 'Serving days are required',
    'Product description is required': 'Product description is required',
    'Cuisine is required': 'Cuisine is required',
    'product sku is required': 'SKU is required',
    'Recipe with is required': 'Recipe with is required',
    'meal_type is required': 'Meal type is required',
    'serving_size is required': 'Serving size is required',

    // MerchantDocumnet Errors
    'Invalid fileName. Allowed: businessLicense, retailFoodEstablishmentLicense, foodServiceSanitationCertificate, federalEin, salesTax, ownerPhotoId':
      'The selected document type is not supported. Please refresh the page and try again.',
    'kitchenName and fileName are required': 'Kitchen name and document type are required',
    'Something is seriouly wrong,This is last CATCH block,Check your error database collection':
      'Something went seriously wrong. Please contact support and provide reference - 556688',
    'kitchenName is required': 'Please refresh the page and try again.',
  };

  return errorMappingList[error] || error;
};

export default responseErrorMapping;
